import React from 'react';
import { MenuGroups, MenuLink } from './MenuLinks';
import { AnimatePresence, motion } from 'framer-motion';
import { Link } from 'gatsby';
import { FormattedMessage } from 'react-intl';
import { Heading3, Heading2 } from '@entur/typography';
import './MobileMenu.scss';

export const MobileMenu = ({
  open,
  isDoneAnimate,
  closeMenu,
}: {
  open: boolean;
  isDoneAnimate: () => void;
  closeMenu: () => void;
}) => {
  return (
    <div className="omtur-menu-wrapper">
      <AnimatePresence onExitComplete={isDoneAnimate}>
        {open && <SideNavigationMenu closeMenu={closeMenu} />}
      </AnimatePresence>
    </div>
  );
};

const openTime = 0.2;
const sideMenu = {
  closed: { opacity: 0, height: '0rem' },
  open: {
    opacity: 1,
    height: 'fit-content',
    transition: {
      ease: 'easeOut',
      duration: openTime,
      delayChildren: openTime,
    },
  },
  out: {
    opacity: 1,
    height: 0,
    transition: {
      ease: 'easeOut',
      duration: openTime,
    },
  },
};

const item = {
  open: { opacity: 1, y: 0 },
  closed: { opacity: 0, y: 30 },
  out: { opacity: 0, y: 30 },
};
const SideNavigationMenu = ({ closeMenu }: { closeMenu: () => void }) => {
  return (
    <motion.div
      initial="closed"
      animate="open"
      exit="out"
      variants={sideMenu}
      className="omtur-mobile-sidenavigation__container eds-contrast"
    >
      <motion.div
        className="omtur-dropdown-menu__item omtur-dropdown-menu__item--vertical"
        variants={item}
        transition={{ ease: 'easeOut', duration: 0.15 }}
      >
        {MenuGroups.map((group, index) => (
          <div key={index}>
            <Heading2 className="omtur-dropdown-menu__header">
              <FormattedMessage id={group.header} />
            </Heading2>
            {group.links.map((link: MenuLink, index: number) => (
              <NavLink
                key={link.name + index}
                link={link}
                external={link.url ? link.url.startsWith('https') : false}
                closeMenu={closeMenu}
              />
            ))}
          </div>
        ))}
      </motion.div>
    </motion.div>
  );
};

interface NavMenuLinkOptions {
  link: MenuLink;
  external?: boolean;
  closeMenu: () => void;
}

const NavLink = ({ link, external, closeMenu }: NavMenuLinkOptions) => {
  return external ? (
    <a
      href={link.url}
      className="omtur-dropdown-menu__link"
      onClick={closeMenu}
    >
      <Heading3 className="omtur-dropdown-menu__link__text">
        <FormattedMessage id={link.name} />
      </Heading3>
    </a>
  ) : (
    <Link
      to={link.url}
      className="omtur-dropdown-menu__link"
      onClick={closeMenu}
    >
      <Heading3 className="omtur-dropdown-menu__link__text">
        <FormattedMessage id={link.name} />
      </Heading3>
    </Link>
  );
};
